@if ($icon(); as icon) {
    <div class="icon" [style.background-color]="$iconBackground()" [style.color]="$iconColor()">
        @if($iconFont()) {
            <i [class]="icon"></i>
        } @else {
            <span *dynamicView="icon"></span>
        }
    </div>
}

<div class="content">

    @if($header(); as title) {
        <div class="title">
            <span *dynamicView="title"></span>
        </div>
    }

    @if($description(); as description) {
        <div class="description">
            <span *dynamicView="description"></span>
        </div>
    }

    @if($content(); as content) {
        <div class="content">
            <span *dynamicView="content"></span>
        </div>
    }
</div>

@if ($rightContent()) {
    <div class="action">
        <span *dynamicView="$rightContent()"></span>
    </div>
}

@if ($action() || $command()) {
    <div class="action">
        @if($command()) {
            <w-button displayStyle="Tertiary" size="Small" [command]="$command()" />
        } @else {
            <span *dynamicView="$action()"></span>
        }
    </div>
}

@if ($chevron(); as chevron) {
    <div class="chevron">
        @if ($iconFont()) {
            <i [class]="chevron"></i>
        } @else {
            <span *dynamicView="chevron"></span>
        }
    </div>
}